import React from "react";
import {
  ShieldCheck,
  Languages,
  Calendar,
  Ruler,
  Footprints,
  Flag,
  MapPin,
  BadgeCheck
} from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import { playerInfo } from "../mock/mock";
import BrandDivider from "./BrandDivider";

const ScoutingProfile = () => {
  const { t } = useLanguage();

  const dataCells = [
    { label: t("profile.labels.dob"), value: t("profile.values.dob"), Icon: Calendar },
    { label: t("profile.labels.nationality"), value: playerInfo.nationality, Icon: Flag },
    { label: t("profile.labels.height"), value: playerInfo.height, Icon: Ruler },
    { label: t("profile.labels.foot"), value: t("profile.values.foot"), Icon: Footprints },
    { label: t("profile.labels.club"), value: t("profile.values.club"), Icon: MapPin },
    { label: t("profile.labels.languages"), value: t("profile.values.languages"), Icon: Languages },
    { label: t("profile.labels.contract"), value: t("profile.values.contract"), Icon: ShieldCheck },
    { label: t("profile.labels.status"), value: t("profile.values.status"), Icon: BadgeCheck }
  ].filter((c) => c.value && String(c.value).trim() !== "");

  return (
    <section id="profile" className="relative py-20 md:py-28 bg-caliza text-ink">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-[1px] bg-marseille" />
              <span className="text-[11px] uppercase tracking-[0.3em] text-marseille font-semibold">
                {t("profile.eyebrow")}
              </span>
            </div>
            <h2 className="font-hero text-marseille text-4xl md:text-6xl">
              <span style={{ fontWeight: 300 }}>{t("profile.title")}</span>
              <span style={{ fontWeight: 700 }}>{t("profile.titleHighlight")}</span>
            </h2>
          </div>
          <p className="max-w-xl text-ink/80 leading-relaxed text-[15px]">
            {t("profile.summary")}
          </p>
        </div>

        <BrandDivider color="#1F6DB0" opacity={0.3} className="mb-10" />

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-marseille/15">
          {dataCells.map(({ label, value, Icon }) => (
            <div
              key={label}
              className="bg-white p-6 md:p-7 flex items-start gap-4 transition-colors hover:bg-caliza"
            >
              <div className="w-10 h-10 flex items-center justify-center border border-marseille/40 text-marseille shrink-0">
                <Icon size={16} />
              </div>
              <div className="min-w-0">
                <div className="text-[10px] uppercase tracking-[0.28em] text-marseille/70 mb-1 font-medium">
                  {label}
                </div>
                <div className="text-ink text-[15px] leading-snug break-words font-semibold">
                  {value}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ScoutingProfile;
